import { EndorsementKey, type EndorsementConfig } from './types';
import { config as equipmentBreakdownConfig } from './components/EquipmentBreakdown/EquipmentBreakdown.config';
import { config as restaurantCoverageConfig } from './components/RestaurantCoverage/RestaurantCoverage.config';
import { config as cyberCoverageConfig } from './components/CyberInsurance/CyberInsurance.config';
import { config as workplaceViolenceConfig } from './components/WorkplaceViolence/WorkplaceViolence.config';
import { config as epliConfig } from './components/EPLI/EPLI.config';
import { config as hiredAutoConfig } from './components/HiredAuto/HiredAuto.config';
import { config as liquorLiabilityConfig } from './components/LiquorLiability/LiquorLiability.config';
import { config as contractorToolsConfig } from './components/ContractorTools/ContractorTools.config';
import { config as damagesToPremisesConfig } from './components/DamagesToPremisesRented/DamagesToPremisesRented.config';

export type EndorsementRegistry = {
  [key: string]: EndorsementConfig;
};

export const endorsementRegistry: EndorsementRegistry = {
  [EndorsementKey.EquipmentBreakdownEndorsement]: equipmentBreakdownConfig,
  [EndorsementKey.RestaurantCoverage]: restaurantCoverageConfig,
  [EndorsementKey.CyberCoverage]: cyberCoverageConfig,
  [EndorsementKey.WorkplaceViolenceCoverage]: workplaceViolenceConfig,
  [EndorsementKey.EpliCoverage]: epliConfig,
  [EndorsementKey.HiredAutoAndNonOwnedAuto]: hiredAutoConfig,
  [EndorsementKey.LiquorLiabilityEndorsement]: liquorLiabilityConfig,
  [EndorsementKey.ContractorsInstallationAndTools]: contractorToolsConfig,
  [EndorsementKey.LimitDamagePremRented]: damagesToPremisesConfig,
};
